"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var instantDiscountApi = _interopRequireWildcard(require("@/api/instantDiscountApi.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MARKETER_MAP = {
  1: '平台',
  2: '商家'
};
var ACTIVITY_TYPE_MAP = {
  1: '折扣'
};
var ACTIVITY_SCENE_MAP = {
  1: '线下门店核销'
};
var STATUS_MAP = {
  1: '长期有效',
  2: '指定时间段有效',
  3: '禁用'
};
var THRESHOLD_CALC_TYPE_MAP = {
  1: '订单金额',
  2: '实际支付金额'
};
var DISCOUNT_CALC_TYPE_MAP = {
  1: '按实际支付金额进行计算'
};
var STACK_CALC_TYPE_MAP = {
  1: '优惠券抵扣前订单金额',
  2: '优惠券抵扣后订单金额'
};
var REFUND_TYPE_MAP = {
  1: '仅按比例分摊，不重新校验门槛'
};
var APPORTION_TYPE_MAP = {
  1: '订单金额'
};
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      side: 'after',
      // 'before' | 'after'，决定渲染哪一份快照
      logInfo: {},
      // 日志表头（opType/operator/createTime/remark）
      detail: {},
      // 当前 side 对应的快照 activity 对象
      paymentListRaw: [],
      // 当前 side 对应的快照 paymentList 实体
      couponIds: [],
      // 当前 side 对应的快照 couponIds
      couponNames: [],
      // 当前 side 对应的快照 couponNames（与 couponIds 一一对应）
      supplierList: [],
      customerList: [],
      fucardList: [],
      storeList: []
    };
  },
  computed: {
    paymentList: function paymentList() {
      var _this = this;
      var list = Array.isArray(this.paymentListRaw) ? this.paymentListRaw : [];
      return list.map(function (p) {
        return _objectSpread(_objectSpread({}, p), {}, {
          paymentName: _this.getPaymentName(p)
        });
      });
    },
    couponIdsText: function couponIdsText() {
      if (!this.couponIds || this.couponIds.length === 0) return '';
      // 优先用快照里的优惠券名称；为空时回退到 ID
      var names = Array.isArray(this.couponNames) ? this.couponNames : [];
      return this.couponIds.map(function (id, i) {
        var n = names[i];
        return n && n.length > 0 ? n : "ID:".concat(id);
      }).join('、');
    }
  },
  methods: {
    /**
     * 父组件调用入口
     * @param {number} id 日志行 id
     * @param {'before'|'after'} side 改前/改后快照
     */
    openInit: function openInit(id, side) {
      this.logInfo = {};
      this.detail = {};
      this.paymentListRaw = [];
      this.couponIds = [];
      this.couponNames = [];
      this.side = side || 'after';
      this.dialogVisible = true;
      this.loadSupplierList();
      this.loadCustomerList();
      this.loadFucardList();
      this.loadDetail(id);
    },
    loadDetail: function loadDetail(id) {
      var _this2 = this;
      if (!id) return;
      this.loading = true;
      instantDiscountApi.instantDiscountOpLogInfo(id).then(function (res) {
        _this2.logInfo = res || {};
        var snapshotStr = _this2.side === 'before' ? res && res.beforeData : res && res.afterData;
        _this2.parseSnapshot(snapshotStr);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
     * 解析 beforeData / afterData JSON
     * 结构: { activity: {...}, paymentList: [...], couponIds: [...] }
     */
    parseSnapshot: function parseSnapshot(snapshotStr) {
      if (!snapshotStr) {
        this.detail = {};
        this.paymentListRaw = [];
        this.couponIds = [];
        this.couponNames = [];
        return;
      }
      var parsed = null;
      try {
        parsed = JSON.parse(snapshotStr);
      } catch (e) {
        parsed = null;
      }
      if (!parsed || _typeof(parsed) !== 'object') {
        this.detail = {};
        this.paymentListRaw = [];
        this.couponIds = [];
        this.couponNames = [];
        return;
      }
      // 冻结快照，阻止 Vue 深度响应式代理（避免大对象卡死主线程）
      this.detail = Object.freeze(parsed.activity || {});
      this.paymentListRaw = Object.freeze(Array.isArray(parsed.paymentList) ? parsed.paymentList : []);
      this.couponIds = Object.freeze(Array.isArray(parsed.couponIds) ? parsed.couponIds : []);
      this.couponNames = Object.freeze(Array.isArray(parsed.couponNames) ? parsed.couponNames : []);
      // 加载门店列表用于显示门店名称
      if (this.detail.supplierId) {
        this.loadStoreList(this.detail.supplierId);
      }
    },
    loadSupplierList: function loadSupplierList() {
      var _this3 = this;
      instantDiscountApi.supplierList().then(function (res) {
        _this3.supplierList = res || [];
      });
    },
    loadCustomerList: function loadCustomerList() {
      var _this4 = this;
      instantDiscountApi.getMiniappList('').then(function (res) {
        _this4.customerList = res || [];
      });
    },
    loadFucardList: function loadFucardList() {
      var _this5 = this;
      instantDiscountApi.getFucardList('').then(function (res) {
        _this5.fucardList = res || [];
      });
    },
    loadStoreList: function loadStoreList(supplierId) {
      var _this6 = this;
      if (!supplierId) return;
      instantDiscountApi.getStoreListBySupplierId(supplierId).then(function (res) {
        _this6.storeList = (res || []).map(function (item) {
          return {
            id: item.key,
            name: item.value
          };
        });
      }).catch(function () {
        _this6.storeList = [];
      });
    },
    getPaymentName: function getPaymentName(p) {
      if (!p) return '-';
      if (p.fuCardId === -1) return '微信支付';
      var found = this.fucardList.find(function (f) {
        return f.id === p.fuCardId;
      });
      if (!found) return '-';
      return found.card_name || found.cardName || found.name || found.title || '-';
    },
    formatDiscountValue: function formatDiscountValue(val) {
      if (val === null || val === undefined) return '-';
      return Number(val).toFixed(2).replace(/\.?0+$/, '');
    },
    getMarketerName: function getMarketerName(val) {
      return MARKETER_MAP[val] || '-';
    },
    getActivityTypeName: function getActivityTypeName(val) {
      return ACTIVITY_TYPE_MAP[val] || '-';
    },
    getActivitySceneName: function getActivitySceneName(val) {
      return ACTIVITY_SCENE_MAP[val] || '-';
    },
    getStatusName: function getStatusName(val) {
      return STATUS_MAP[val] || '-';
    },
    getThresholdCalcTypeName: function getThresholdCalcTypeName(val) {
      return THRESHOLD_CALC_TYPE_MAP[val] || '-';
    },
    getDiscountCalcTypeName: function getDiscountCalcTypeName(val) {
      return DISCOUNT_CALC_TYPE_MAP[val] || '-';
    },
    getStackCalcTypeName: function getStackCalcTypeName(val) {
      return STACK_CALC_TYPE_MAP[val] || '-';
    },
    getRefundTypeName: function getRefundTypeName(val) {
      return REFUND_TYPE_MAP[val] || '-';
    },
    getApportionTypeName: function getApportionTypeName(val) {
      return APPORTION_TYPE_MAP[val] || '-';
    },
    getSupplierName: function getSupplierName(supplierId) {
      if (supplierId === null || supplierId === undefined) return '-';
      var found = this.supplierList.find(function (s) {
        return s.id === supplierId;
      });
      return found ? found.supplierName : '-';
    },
    getCustomerName: function getCustomerName(customerId) {
      if (customerId === null || customerId === undefined) return '-';
      var found = this.customerList.find(function (c) {
        return c.customerId === customerId;
      });
      return found ? found.appName : '-';
    },
    getStoreNames: function getStoreNames(storeIds) {
      var _this7 = this;
      // 空值、空字符串、null、undefined 都视为"全部门店"
      if (storeIds === null || storeIds === undefined || storeIds === '') {
        return '全部门店';
      }
      // 解析 storeIds（可能是逗号分隔的字符串或数组）
      var idArr = typeof storeIds === 'string' ? storeIds.split(',').map(function (id) {
        return parseInt(id.trim());
      }).filter(function (id) {
        return !isNaN(id);
      }) : Array.isArray(storeIds) ? storeIds : [];
      if (idArr.length === 0) {
        return '全部门店';
      }
      var names = idArr.map(function (id) {
        var store = _this7.storeList.find(function (s) {
          return s.id === id;
        });
        return store ? store.name : '';
      }).filter(function (name) {
        return name;
      });
      return names.length > 0 ? names.join('，') : '全部门店';
    },
    getOpTypeTag: function getOpTypeTag(opType) {
      switch (opType) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        case 4:
          return 'info';
        default:
          return '';
      }
    },
    formatDateTime: function formatDateTime(val) {
      if (!val) return '-';
      var d = new Date(val);
      if (isNaN(d.getTime())) return '-';
      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    },
    handleClose: function handleClose() {
      this.detail = {};
      this.logInfo = {};
      this.paymentListRaw = [];
      this.couponIds = [];
      this.couponNames = [];
    }
  }
};